var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"body-wrap"}},[_c('LayoutHeader'),_c('Lfcnvnc'),_c('Footer'),_c('FooterPc'),_c('Common'),_c('PulseLoader',{attrs:{"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }